"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillSelectFormItemWrapper = exports.AddExpressionButton = exports.RemoveButton = exports.ExperienceDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const antd_1 = require("antd");
exports.ExperienceDiv = styled_components_1.default.div `
	background-color: #f1f1f1;
	display: flex;
	flex-direction: column;
	min-width: 0;
	border-radius: 5px;
	padding: 1rem;
	margin-bottom: 1rem;
`;
exports.RemoveButton = (0, styled_components_1.default)(elements_1.Button) `
	width: fit-content;
`;
exports.AddExpressionButton = (0, styled_components_1.default)(elements_1.Button) `
	width: 100%;
	display: flex;
	align-items: center;
	padding: 0.25rem 0.75rem;
`;
exports.SkillSelectFormItemWrapper = (0, styled_components_1.default)(antd_1.Form.Item) `
	width: 100%;
	.ant-select-selector {
		padding: 0.25rem;
	}
`;
